(function(){
    'use strict';
    
    // Check is my programs tabs wrapper is on page
    var my_tabs_exists = !!document.querySelector('.my-program-tabs__wrapper');

    // If my tabs is on the page
    if (my_tabs_exists) {

        // get all tabs from on page
        var all_my_tabs = document.querySelectorAll('.my-program-tabs__wrapper');

        // Loop through all tabs
        for (var i = 0; i < all_my_tabs.length; i++) {
            
            // Initialize the tabs
            initTabs(all_my_tabs[i]);
            
        }

    }
    
}());

function initTabs(tabs_wrapper) {

    // get all the buttons in the tabs wrapper
    var tabs_button = tabs_wrapper.querySelectorAll('.my-program-tabs__button');

    // Get all the tabs content
    var tabs_content = tabs_wrapper.querySelectorAll('.my-program-tabs__content');

    // Loop through each button
    for (var i = 0; i < tabs_button.length; i++) {
        
        // Add a click event listener for each button
        tabs_button[i].addEventListener('click', function(){

            // if it's the current tab and mobile open the dropdown list
            if (this["parentElement"]["classList"].contains('my-program-tabs__item--current')) {

                // if it's mobile
                if (!window.matchMedia("(min-width: 992px)")["matches"]) {

                    // Toggle the dropdown menu
                    this["parentElement"]["parentElement"]["classList"].toggle('my-program-tabs__list--open');

                }

            } else {

                if (!window.matchMedia("(min-width: 992px)")["matches"]) {

                    // Close the dropdown menu
                    this["parentElement"]["parentElement"]["classList"].remove('my-program-tabs__list--open');

                    // Prepend the current buttons container to the list so it appears on top when opening the menu again
                    // this["parentElement"]["parentElement"].prepend(this["parentElement"]);

                }

                // Remove currently active class from all tabs
                for (let j = 0; j < tabs_button.length; j++) {
                    
                    tabs_button[j]["parentElement"]["classList"].remove('my-program-tabs__item--current');

                }

                // Ste the current class on the containing element
                this["parentElement"]["classList"].add('my-program-tabs__item--current');

            }

            // Change the content based on the selected tab
            for (let i = 0; i < tabs_content.length; i++) {
                tabs_content[i]["classList"].remove('my-program-tabs__content--open');
            }

            document.querySelector(this["dataset"]["targetTab"])["classList"].add('my-program-tabs__content--open');

        });
        
    }

}


(function(){
    'use strict';
    

    squiz['fn']['colour'] = {};


    

    squiz['fn']['colour']['compileCourseCodes'] = function(data, existing_codes){
        var course_codes = {};
        if(typeof existing_codes != 'undefined'){
            course_codes = existing_codes;
        }
        var all_data = [];

        var is_array = Array.isArray(data);
        if(is_array){
            all_data = data;
        } else {
            for(var key in data){
                all_data = all_data.concat(data[key]);
            }
        }
        
        // loop thorugh 
        for(var index = 0; index < all_data.length; index++){
            var this_course_code = all_data[index]['courseCode'];
            if(typeof this_course_code == 'undefined'){
                this_course_code = all_data[index]['code'];
            }
            // if the code DOES NOT exist in the code code, add it.
            // the empty ob object will be given a hexdecimal colour code later (in assignColoursToData())
            if(this_course_code && !course_codes[this_course_code]){
                course_codes[this_course_code] = {};
            }
        }

        return course_codes;
    };

    squiz['fn']['colour']['randomlyAssignColoursToCourseCodes'] = function(codes, GSP_DATA_COLOUR_SCHEMES){
        var course_codes = codes;
        var base_colours = GSP_DATA_COLOUR_SCHEMES;
        var base_colours_counter = 0;

        for (var key in course_codes){
            if(base_colours_counter <= GSP_DATA_COLOUR_SCHEMES.length){
                course_codes[key] = base_colours[base_colours_counter];
            }
            base_colours_counter = base_colours_counter + 1;
        }
        return course_codes;
    };

    squiz['fn']['colour']['assignColoursToData'] = function(data, mapped_course_codes){
        var updated_data = data;
        var default_scheme = {"name": "default", "code": "#000000"};
        // update keydates
        for(var index = 0; index < updated_data.length; index++){
            var this_course_code = updated_data[index]['courseCode'];
            if(typeof this_course_code == 'undefined'){
                this_course_code = updated_data[index]['code'];
            }
            var colour_scheme = mapped_course_codes[this_course_code];
            if(typeof colour_scheme != 'undefined'){
                updated_data[index]['colour'] = colour_scheme;
            } else {
                updated_data[index]['colour'] = default_scheme;
            }
        }

        return updated_data;
    };
    


}());